import loader from './lib/Loader';
// import '@lottiefiles/lottie-player';

import(/* webpackPrefetch: true */ './icons');
loader('slider', '.slider');
loader('navbar', '.header');
loader('menu', '.header');
loader('searchbar', '.header');
loader('snb-slider', '.snb-slider__item');
loader('form', '.gform_body');
